// SearchBar.jsx
import React from "react";
import { Input } from "../ui/Input";

export const SearchBar = ({ onSearch, placeholder = "Busca tu opción" }) => {
  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    onSearch(searchTerm);
  };

  return (
    <div className="w-[60%]">
      {" "}
      {/* Ajustado al 60% */}
      <div className="relative bg-orange-50/80 rounded-full shadow-[0_2px_8px_rgba(0,0,0,0.1)] overflow-hidden">
        <Input
          type="search"
          placeholder={placeholder}
          className="w-full h-12 pl-6 pr-12 border-none focus:ring-0 focus:outline-none bg-transparent placeholder-gray-500"
          onChange={handleSearch}
        />
        <button className="absolute right-0 top-0 h-full px-6 bg-orange-500 text-white flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
